import {
  WideCoinsEmptyState,
  ConnectEmptyState,
  DarkCoinsEmptyState,
  DarkConnectEmptyState,
  DarkDefaultEmptyState,
  DarkGraphDataEmptyState,
  DarkMarketplaceEmptyState,
  DarkPayoutMethodsEmptyState,
  DarkFileSearchEmptyState,
  DarkSignalsEmptyState,
  DarkTradesEmptyState,
  DefaultEmptyState,
  GraphDataEmptyState,
  MarketplaceEmptyState,
  PayoutMethodsEmptyState,
  SearchEmptyState,
  FileSearchEmptyState,
  SignalsEmptyState,
  TradesEmptyState,
  DarkSearchEmptyState,
  DarkReviewsEmptyState,
  ReviewsEmptyState,
  BotsEmptyState,
  DarkBotsEmptyState,
  DarkWideCoinsEmptyState,
  CoinsEmptyState,
  BacktestingHistoryEmptyState,
  DarkBacktestingHistoryEmptyState,
  DarkConfigurationEmptyState,
  ConfigurationEmptyState,
  DarkConfigurationSearchEmptyState,
  ConfigurationSearchEmptyState,
  UsersEmptyState,
  DarkUsersEmptyState,
  DarkFiltersEmptyState,
  FiltersEmptyState,
  GearsEmptyState,
  DarkGearsEmptyState,
  InvoicesEmptyState,
  DarkInvoicesEmptyState,
} from "common/Icons/Icons.tsx";
import { useTheme } from "styled-components";
import { EmptyStatesIcons } from "common/Icons/types.ts";
import {
  ArrowLeftRight,
  Bot,
  ChartLine,
  Coins,
  FileSearch,
  History,
  Inbox,
  ListFilter,
  MessageSquareText,
  Plug,
  Radio,
  Receipt,
  Search,
  SearchX,
  Settings,
  SlidersHorizontal,
  Store,
  Users,
  Wallet,
} from "lucide-react";
import { createEmptyIllustration } from "common/Empty/EmptyIllustration.tsx";

const NEW_LOOK_EMPTY_STATES: EmptyStatesIcons = {
  Empty: createEmptyIllustration(Inbox),
  Trades: createEmptyIllustration(ArrowLeftRight),
  Signals: createEmptyIllustration(Radio),
  Graph: createEmptyIllustration(ChartLine),
  Marketplace: createEmptyIllustration(Store),
  Coins: createEmptyIllustration(Coins),
  WideCoins: createEmptyIllustration(Coins),
  PayoutMethods: createEmptyIllustration(Wallet),
  Connect: createEmptyIllustration(Plug),
  FileSearch: createEmptyIllustration(FileSearch),
  Search: createEmptyIllustration(Search),
  Reviews: createEmptyIllustration(MessageSquareText),
  Bots: createEmptyIllustration(Bot),
  BacktestingHistory: createEmptyIllustration(History),
  Configuration: createEmptyIllustration(SlidersHorizontal),
  ConfigurationSearch: createEmptyIllustration(SearchX),
  Users: createEmptyIllustration(Users),
  Filters: createEmptyIllustration(ListFilter),
  Gears: createEmptyIllustration(Settings),
  Invoices: createEmptyIllustration(Receipt),
};

export const useEmptyState = () => {
  const theme = useTheme();
  if (theme.isNewLook) return NEW_LOOK_EMPTY_STATES;
  const lightModeEmptyStates: EmptyStatesIcons = {
    Empty: DefaultEmptyState,
    Trades: TradesEmptyState,
    Signals: SignalsEmptyState,
    Graph: GraphDataEmptyState,
    Marketplace: MarketplaceEmptyState,
    Coins: CoinsEmptyState,
    WideCoins: WideCoinsEmptyState,
    PayoutMethods: PayoutMethodsEmptyState,
    Connect: ConnectEmptyState,
    FileSearch: FileSearchEmptyState,
    Search: SearchEmptyState,
    Reviews: ReviewsEmptyState,
    Bots: BotsEmptyState,
    BacktestingHistory: BacktestingHistoryEmptyState,
    Configuration: ConfigurationEmptyState,
    ConfigurationSearch: ConfigurationSearchEmptyState,
    Users: UsersEmptyState,
    Filters: FiltersEmptyState,
    Gears: GearsEmptyState,
    Invoices: InvoicesEmptyState,
  };
  const darkModeEmptyStates: EmptyStatesIcons = {
    Empty: DarkDefaultEmptyState,
    Trades: DarkTradesEmptyState,
    Signals: DarkSignalsEmptyState,
    Graph: DarkGraphDataEmptyState,
    Marketplace: DarkMarketplaceEmptyState,
    Coins: DarkCoinsEmptyState,
    WideCoins: DarkWideCoinsEmptyState,
    PayoutMethods: DarkPayoutMethodsEmptyState,
    Connect: DarkConnectEmptyState,
    FileSearch: DarkFileSearchEmptyState,
    Search: DarkSearchEmptyState,
    Reviews: DarkReviewsEmptyState,
    Bots: DarkBotsEmptyState,
    BacktestingHistory: DarkBacktestingHistoryEmptyState,
    Configuration: DarkConfigurationEmptyState,
    ConfigurationSearch: DarkConfigurationSearchEmptyState,
    Users: DarkUsersEmptyState,
    Filters: DarkFiltersEmptyState,
    Gears: DarkGearsEmptyState,
    Invoices: DarkInvoicesEmptyState,
  };

  return theme.isDarkMode ? darkModeEmptyStates : lightModeEmptyStates;
};
